import { fetcher } from '@cloudron/pankow';
import { API_ORIGIN } from '../utils.js';

async function list() {
  let error, result;
  try {
    result = await fetcher.get(`${API_ORIGIN}/api/v1/shares`);
  } catch (e) {
    error = e;
  }

  if (error || result.status !== 200) throw new Error('Failed to list shares', { cause: error || result })

  // translate for local development
  result.body.shares.forEach((s) => {
    s.file.previewUrl = `${API_ORIGIN}${s.file.previewUrl}`;
  });

  return result.body.shares;
}

async function create(data) {
  let tmp = {
    path: data.path,
    readonly: data.readonly
  };

  if (data.ownerUserId) tmp.ownerUserId = data.ownerUserId;
  if (data.ownerGroupfolder) tmp.ownerGroupfolder = data.ownerGroupfolder;
  // API: expiresAt is Unix time in milliseconds (finite number), or omit for no expiration
  if (typeof data.expiresAt === 'number' && Number.isFinite(data.expiresAt) && data.expiresAt > 0) tmp.expiresAt = data.expiresAt;
  if (data.receiverUserId) tmp.receiverUserId = data.receiverUserId;
  if (data.receiverGroup) tmp.receiverGroup = data.receiverGroup;
  if (data.password) tmp.password = data.password;
  if (data.name) tmp.name = data.name;

  let error, result;
  try {
    result = await fetcher.post(`${API_ORIGIN}/api/v1/shares`, tmp);
  } catch (e) {
    error = e;
  }

  if (error || result.status !== 200) throw new Error('Failed to create shared', { cause: error || result })

  return result.body.shareId;
}

async function unlock(shareId, password) {
  let error, result;
  try {
    result = await fetcher.post(`${API_ORIGIN}/api/v1/shares/${shareId}/unlock`, { password });
  } catch (e) {
    error = e;
  }

  if (error || result.status !== 200) throw new Error('Failed to unlock share', { cause: error || result });
}

async function remove(shareId) {
  let error, result;
  try {
    result = await fetcher.del(`${API_ORIGIN}/api/v1/shares`, {}, { shareId });
  } catch (e) {
    error = e;
  }

  if (error || result.status !== 200) throw new Error('Failed to delete share', { cause: error || result })
}

function getLink(shareId) {
  return `${window.location.origin}/api/v1/shares/${shareId}?type=raw`;
}

export default {
  list,
  create,
  remove,
  unlock,
  getLink,
};
